import { gql } from "apollo-boost";
import React from "react";
import { useMutation, useQuery } from "react-apollo-hooks";
import Helmet from "react-helmet-async";
import { Container } from "../../components/Grid";
import { Title } from "../../components/Headings";
import SearchField from "../../components/SearchField";
import Text from "../../components/Text";
import filterProducts, {
  fragment as ProductsSearchFragment
} from "./filterProducts";
import ProductCard, { fragment as ProductCardFragment } from "./ProductCard";

export default function ProductsPage(props) {
  // Use a mutation to update the filter text.
  const updateFilterText = useMutation(UPDATE_FILTER_TEXT);
  const { projectId, lang, producerId, location, producer = {} } = props;
  const { data = {} } = useQuery(query, {
    variables: { lang, projectId, producerId },
    suspend: true
  });
  const { filter, project = {} } = data || {};
  const { productsConnection: { totalCount, edges = [] } = {} } = project || {};
  // Show only the filtered products.
  const products = filterProducts(edges.map(({ node }) => node || {}), filter);

  return (
    <Container key={location.key}>
      <Helmet>
        <title>
          {producer.producerName
            ? `Produkte von ${producer.producerName.name}`
            : "Produkte"}
        </title>
      </Helmet>

      <SearchField
        variant="large"
        mt={5}
        placeholder="Nach Herkunft, Name oder Jahrgang suchen"
        value={filter && filter.text}
        onChange={e =>
          updateFilterText({ variables: { text: e.target.value } })
        }
      />

      <Title my={5}>
        Zeige{" "}
        <Text as="span" color="primary">
          {products.length}
        </Text>{" "}
        {products.length !== totalCount ? (
          <>
            {" "}
            von{" "}
            <Text as="span" color="primary">
              {totalCount}
            </Text>{" "}
            Produkten
          </>
        ) : (
          "Produkte"
        )}
        {filter && filter.text && (
          <>
            {" "}
            mit "
            <Text as="span" color="primary">
              {filter.text}
            </Text>
            "
          </>
        )}
      </Title>

      {products.map(product => (
        <ProductCard
          withBorder
          key={product.id}
          {...product}
          to={`./${product.id}`}
        />
      ))}
    </Container>
  );
}

const UPDATE_FILTER_TEXT = gql`
  mutation updateFilterText($text: String!) {
    updateProductsFilterText(text: $text) @client
  }
`;

export const fragment = gql`
  fragment ProductsList on ProductsConnection {
    totalCount
    edges {
      node {
        id
        ...ProductCard
      }
    }
  }
  ${ProductCardFragment}
`;
export const query = gql`
  query ProductsList($projectId: ID!, $lang: String) {
    filter: productsFilter @client {
      text
    }
    project(id: $projectId, lang: $lang) {
      productsConnection {
        ...ProductsList
        ...ProductsSearch
      }
    }
  }
  ${fragment}
  ${ProductsSearchFragment}
`;
